import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { MdOutlineMail } from "react-icons/md";
import { Link } from "react-scroll";

const SocialLinks = ({ inline = false }) => {
  const links = [
    {
      id: 1,
      label: "LinkedIn",
      icon: <FaLinkedin />,
      href: "https://www.linkedin.com/in/yemane-berhane-996691153/",
      color: "from-blue-600 to-blue-700",
      hoverColor: "hover:from-blue-500 hover:to-blue-600",
    },
    {
      id: 2,
      label: "GitHub",
      icon: <FaGithub />,
      href: "https://github.com/berhane02",
      color: "from-gray-700 to-gray-800",
      hoverColor: "hover:from-gray-600 hover:to-gray-700",
    },
    {
      id: 3,
      label: "Email",
      icon: <MdOutlineMail />,
      href: "",
      to: "contact",
      color: "from-cyan-600 to-cyan-700",
      hoverColor: "hover:from-cyan-500 hover:to-cyan-600",
      isScroll: true,
    },
  ];

  // If inline, render inline version; otherwise render fixed version
  if (inline) {
    return (
      <ul className="flex flex-row gap-2">
        {links.map(({ id, label, icon, href, to, download, color, hoverColor, isScroll }) => {
          const content = (
            <div
              className={`group relative flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-gradient-to-r ${color} ${hoverColor} transition-all duration-300 ease-out shadow-lg hover:shadow-xl cursor-pointer overflow-hidden`}
            >
              {/* Animated Background Glow */}
              <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              {/* Icon - Always Visible */}
              <div className="flex-shrink-0 text-white group-hover:scale-110 group-hover:rotate-12 transition-all duration-300 z-10 flex items-center justify-center">
                <div className="w-4 h-4 sm:w-5 sm:h-5">
                  {React.cloneElement(icon, { className: "w-full h-full" })}
                </div>
              </div>
            </div>
          );

          if (isScroll && to) {
            return (
              <li key={id}>
                <Link to={to} smooth duration={500} className="block">
                  {content}
                </Link>
              </li>
            );
          }

          return (
            <li key={id}>
              <a
                href={href}
                download={download}
                target={download ? undefined : "_blank"}
                rel={download ? undefined : "noreferrer"}
                className="block"
              >
                {content}
              </a>
            </li>
          );
        })}
      </ul>
    );
  }

  return (
    <div className="flex flex-col">
      <ul className="flex flex-col gap-3">
        {links.map(({ id, label, icon, href, to, download, color, hoverColor, isScroll }) => {
          const content = (
            <div
              className={`group/item relative flex items-center w-14 hover:w-44 h-14 px-3 hover:px-5 rounded-r-lg bg-gradient-to-r ${color} ${hoverColor} transition-all duration-300 ease-out shadow-lg hover:shadow-xl cursor-pointer overflow-hidden`}
            >
              {/* Animated Background Glow */}
              <div className="absolute inset-0 bg-white/10 opacity-0 group-hover/item:opacity-100 transition-opacity duration-300"></div>
              
              {/* Icon - Always Visible */}
              <div className="flex-shrink-0 text-white group-hover/item:scale-110 group-hover/item:rotate-12 transition-all duration-300 z-10 flex items-center justify-center w-5 h-5">
                {React.cloneElement(icon, { className: "w-full h-full" })}
              </div>

              {/* Label - Shows on Hover */}
              <div className="ml-3 overflow-hidden flex-1 min-w-0">
                <span className="text-white font-medium text-sm tracking-wide whitespace-nowrap block opacity-0 group-hover/item:opacity-100 group-hover/item:translate-x-0 -translate-x-full transition-all duration-300">
                  {label}
                </span>
              </div>

              {/* Animated Arrow - Shows on Hover */}
              <div className="absolute right-4 text-white opacity-0 group-hover/item:opacity-100 group-hover/item:translate-x-0 translate-x-2 transition-all duration-300 z-10 text-base">
                →
              </div>
            </div>
          );

          if (isScroll && to) {
            return (
              <li key={id}>
                <Link to={to} smooth duration={500} className="block">
                  {content}
                </Link>
              </li>
            );
          }

          return (
            <li key={id}>
              <a
                href={href}
                download={download}
                target={download ? undefined : "_blank"}
                rel={download ? undefined : "noreferrer"}
                className="block"
              >
                {content}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SocialLinks;
